import React, {
  useEffect,
  useState,
} from "react";

import styles from "./Charges.module.css";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

/* =========================================================
   API
========================================================= */

const API_URL =
  "https://coinyoco.world/brobizee-api/partnerdata.php";

/* =========================================================
   DROPDOWN OPTIONS
========================================================= */

const chargeTypes = [
  "Hourly",
  "Daily",
  "Weekly",
  "Monthly",
];

/* =========================================================
   COMPONENT
========================================================= */

export default function Charges({
  onBack,
  onNext,
}) {
  const navigate = useNavigate();

  const {
    userId,
    deviceUuid,
  } = useParams();

  /* =======================================================
     URL
  ======================================================= */

  const basePath =
    userId && deviceUuid
      ? `/${userId}/${deviceUuid}`
      : "";

  const goTo = (path) => {
    navigate(
      basePath
        ? `${basePath}${path}`
        : path
    );
  };

  /* =======================================================
     STORAGE
  ======================================================= */

  const STORAGE_KEY =
    userId && deviceUuid
      ? `partnerProfile_${userId}_${deviceUuid}`
      : "partnerProfile";

  /* =======================================================
     STATE
  ======================================================= */

  const [money, setMoney] =
    useState("");

  const [chargeType, setChargeType] =
    useState("Hourly");

  const [error, setError] =
    useState("");

  const [isSubmitting, setIsSubmitting] =
    useState(false);

  /* =======================================================
     RESTORE
  ======================================================= */

 /* =======================================================
   RESTORE
======================================================= */

useEffect(() => {
  try {
    const saved =
      localStorage.getItem(STORAGE_KEY);

    if (!saved) {
      return;
    }

    const data = JSON.parse(saved);

    if (!data) {
      return;
    }

    /*
    ------------------------------------------------
    MONEY
    ------------------------------------------------
    */

    if (
      data.money !== undefined &&
      data.money !== null &&
      data.money !== ""
    ) {
      setMoney(String(data.money));
    }

    /*
    ------------------------------------------------
    WORKING CHARGES
    ------------------------------------------------

    Database format:

    money = 500.00
    working_charges = Hourly
    */

    if (data.working_charges) {
      const savedType =
        String(
          data.working_charges
        ).trim();

      if (
        chargeTypes.includes(savedType)
      ) {
        setChargeType(savedType);
      }
    }

  } catch (err) {
    console.error(
      "Unable to restore charges:",
      err
    );
  }
}, [STORAGE_KEY]);

  /* =======================================================
     INPUT CHANGE
  ======================================================= */

  const handleMoneyChange = (e) => {
    let value = e.target.value;

    /*
    Only digits + one dot allowed
    */

    value = value.replace(
      /[^0-9.]/g,
      ""
    );

    const parts = value.split(".");

    if (parts.length > 2) {
      value = parts[0] + "." + parts[1];
    }

    if (parts[1] && parts[1].length > 2) {
      value =
        parts[0] +
        "." +
        parts[1].slice(0, 2);
    }

    setMoney(value);
    setError("");
  };

  /* =======================================================
     DROPDOWN CHANGE
  ======================================================= */

  const handleChargeTypeChange = (e) => {
    setChargeType(e.target.value);
    setError("");
  };

  /* =======================================================
     SAVE CHARGES
  ======================================================= */

  const saveCharges = async () => {
    let previousData = {};

    try {
      const saved =
        localStorage.getItem(STORAGE_KEY);

      if (saved) {
        previousData =
          JSON.parse(saved) || {};
      }
    } catch (err) {
      console.error(
        "Unable to read previous data:",
        err
      );
    }

    /*
    ------------------------------------------------
    FINAL VALUES
    ------------------------------------------------
    */

    const numericMoney = Number(money);

    const workingChargesText = chargeType;

    /*
    ------------------------------------------------
    MERGE
    ------------------------------------------------
    */

    const dataToSave = {
      ...previousData,

      secondary_id:
        userId ||
        previousData.secondary_id ||
        "",

      secondary_uuid:
        deviceUuid ||
        previousData.secondary_uuid ||
        "",

      /*
      MONEY (DECIMAL)
      */

      money: numericMoney,

      /*
      WORKING CHARGES (TEXT)
      Format: "Hourly:500"
      */

      working_charges: workingChargesText,

      /*
      KEEP EXISTING PERSONAL DATA
      */

      full_name:
        previousData.full_name || "",

      phone_number:
        previousData.phone_number || "",

      email_id:
        previousData.email_id || "",

      password:
        previousData.password || "",

      confirm_password:
        previousData.confirm_password ||
        "",

      address:
        previousData.address || "",

      age:
        previousData.age || "",

      gender:
        previousData.gender || "",

      bio:
        previousData.bio || "",

      work:
        previousData.work || "",

      experiences:
        previousData.experiences || "",

      document_type:
        previousData.document_type || "",

      upload_documents_images1:
        previousData.upload_documents_images1 ||
        "",

      upload_documents_images2:
        previousData.upload_documents_images2 ||
        "",

      account_type:
        previousData.account_type || "",

      account_holder_name:
        previousData.account_holder_name ||
        "",

      account_number:
        previousData.account_number || "",

      ifsc_code:
        previousData.ifsc_code || "",

      stutes:
        previousData.stutes || "",

      online_stutes:
        previousData.online_stutes || "",

      profile:
        previousData.profile || "",

      profit:
        previousData.profit ?? 0,

      wallet:
        previousData.wallet ?? 0,

      invest:
        previousData.invest ?? 0,

      upi_id:
        previousData.upi_id || "",

      refrences:
        previousData.refrences || "",

      recently_work:
        previousData.recently_work || "",

      secondary_work:
        previousData.secondary_work || "",

      helper_list:
        previousData.helper_list || "",
    };

    console.log(
      "Saving charges data:",
      dataToSave
    );

    const response = await fetch(
      API_URL,
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json",
        },
        body: JSON.stringify(dataToSave),
      }
    );

    const responseText =
      await response.text();

    console.log(
      "Charges API response:",
      responseText
    );

    let result;

    try {
      result = JSON.parse(responseText);
    } catch {
      throw new Error(
        "PHP API returned invalid JSON."
      );
    }

    if (!response.ok) {
      throw new Error(
        result.message ||
          `Server error: ${response.status}`
      );
    }

    if (!result.success) {
      throw new Error(
        result.message ||
          "Charges could not be saved."
      );
    }

    /*
    SAVE COMPLETE DATA LOCALLY
    */

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(dataToSave)
    );

    localStorage.setItem(
      "partnerProfile",
      JSON.stringify(dataToSave)
    );

    if (onNext) {
      await onNext({
        money: numericMoney,
        working_charges:
          workingChargesText,
        chargeType,
      });
    }

    return result;
  };

  /* =======================================================
     NEXT
  ======================================================= */

  const handleNext = async () => {
    if (
      !money ||
      Number(money) <= 0
    ) {
      setError(
        "Please enter a valid charge amount."
      );
      return;
    }

    if (!chargeType) {
      setError(
        "Please select a charge type."
      );
      return;
    }

    if (!userId || !deviceUuid) {
      setError(
        "User ID or Device UUID is missing."
      );
      return;
    }

    try {
      setIsSubmitting(true);

      await saveCharges();

      goTo("/idproffveri");
    } catch (err) {
      console.error(
        "Unable to save charges:",
        err
      );

      setError(
        err.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  /* =======================================================
     BACK
  ======================================================= */

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    navigate(-1);
  };

  /* =======================================================
     RENDER
  ======================================================= */

  return (
    <div className={styles.screenWrapper}>
      <div className={styles.deviceFrame}>
        <div className={styles.scrollContainer}>

          {/* HEADER */}

          <header className={styles.header}>

            <button
              type="button"
              className={styles.backButton}
              onClick={handleBack}
              aria-label="Go Back"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>

            <div
              className={styles.stepIndicator}
            >
              <span
                className={styles.step}
              />

              <span
                className={`${styles.step} ${styles.stepActive}`}
              />

              <span
                className={styles.step}
              />

              <span
                className={styles.step}
              />
            </div>

          </header>

          {/* TITLE */}

          <section
            className={styles.titleSection}
          >
            <h1 className={styles.title}>
              Set your charges
            </h1>

            <p className={styles.subtitle}>
              Enter Your Working Charges
              And Select How You Want To
              Charge Your Customers.
            </p>
          </section>

          {/* INPUT + DROPDOWN */}

          <div className={styles.controlRow}>

            <div
              className={styles.moneyWrapper}
            >
              <span
                className={
                  styles.currencySymbol
                }
              >
                ₹
              </span>

              <input
                type="text"
                inputMode="decimal"
                placeholder="Enter charges"
                value={money}
                onChange={handleMoneyChange}
                className={styles.moneyInput}
                aria-label="Enter your charges"
              />
            </div>

            <div
              className={styles.typeWrapper}
            >
              <label
                className={styles.typeLabel}
              >
                Type
              </label>

              <div className={styles.typeBox}>
                <select
                  value={chargeType}
                  onChange={
                    handleChargeTypeChange
                  }
                  className={styles.typeSelect}
                  aria-label="Charge type"
                >
                  {chargeTypes.map((type) => (
                    <option
                      key={type}
                      value={type}
                    >
                      {type}
                    </option>
                  ))}
                </select>

                <span
                  className={
                    styles.selectArrow
                  }
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#64748b"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </div>
            </div>

          </div>

          {/* PREVIEW */}

          <div className={styles.previewCard}>
            <div
              className={styles.previewRow}
            >
              <span
                className={
                  styles.previewLabel
                }
              >
                You will charge
              </span>

              <span
                className={
                  styles.previewValue
                }
              >
                {money && Number(money) > 0
                  ? `₹${money} / ${chargeType}`
                  : "--"}
              </span>
            </div>

            <p
              className={
                styles.previewHint
              }
            >
              This amount will be shown to
              customers when they book your
              service.
            </p>
          </div>

          {/* ERROR */}

          {error && (
            <div
              className={styles.errorMessage}
              role="alert"
            >
              <span>{error}</span>
            </div>
          )}

          {/* NEXT */}

          <footer
            className={styles.actionFooter}
          >
            <button
              type="button"
              className={`${styles.nextBtn} ${
                !money || Number(money) <= 0
                  ? styles.nextBtnDisabled
                  : ""
              }`}
              onClick={handleNext}
              disabled={isSubmitting}
            >
              {isSubmitting
                ? "Saving..."
                : "Next"}
            </button>
          </footer>

        </div>
      </div>
    </div>
  );
}